<template>
    <aside class="menu pt-1 user-menu">
        <div
            class="is-size-4 pl-5 pt-5 pb-3 pr-0 mr-5 has-text-eduloc-red is-uppercase menu-title" v-if="isCoordinator" v-html="schoolName"
        >
           
    </div>
        <ul class="menu-list" v-if="isCoordinator">
            <li v-if="hasSchool" class="mx-4">
                <router-link
                    v-t="'entity_projects'"
                    :to="{
                        path: '/management',
                    }"
                    exact
                />
            </li>
            <li class="mx-4">
                <router-link
                    v-t="'app_list_projects'"
                    :to="{ name: 'entityAppContent' }"
                    exact
                />
            </li>
            <li class="mx-4">
                <router-link
                    v-t="'users_management'"
                    :to="{ name: 'entityUsers' }"
                    exact
                />
            </li>
            <li class="mx-4">
                <router-link
                    v-t="'entity_stats'"
                    :to="{ name: 'entityStats' }"
                    exact
                />
            </li>
            
        </ul>

        
    </aside>
</template>

<script>
export default {
    props: {
        folders: { type: Array, default: () => [] },
    },
    data() {
        return {
            dropdownText: 'mine',
            menuActive: 'projects',
            activeSelection: 'mine',
        };
    },
    mounted() {
    },
    computed: {
        hasSchool() {
            return this.$store.getters.hasSchool;
        },
        schoolName() {
            let text = this.$store.getters.school.name;
            return text
                .split(/\s-\s/)      // separem pels " - "
                .map(t => `<p>${t}</p>`)
                .join("");
            // return this.$store.getters.school.name.replace(/ - /g, "<br>");
            // return this.$store.getters.school.name;
        },
        isCoordinator() {
            return this.$store.getters.hasSchool && this.$store.getters.canManageSchool;
        },
        isAdmin() {
            return this.$store.getters.isAdmin;
        },
        
        
    },
    methods: {
        setMenuActive(element) {
            if (this.menuActive == element) {
                this.menuActive = '';
            } else {
                this.menuActive = element;
            }
        },
    },
};
</script>

<style scooped>
    aside.user-menu{
        height: calc(100vh - 5.2rem);
    }
    .menu-title{
        max-width: 300px;
    }
</style>


